import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { setupGlobalErrorHandlers } from './utils/setupGlobalErrorHandlers'
import { formatDateTime } from './utils/datetime'
import { useCsNotifyStore } from './stores/cs-notify'
import { useFinancePendingNotifyStore } from './stores/finance-pending-notify'

const app = createApp(App)
app.config.globalProperties.$formatDT = formatDateTime
setupGlobalErrorHandlers(app)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, { locale: zhCn })
app.use(createPinia())
app.use(router)

if (typeof localStorage !== 'undefined' && localStorage.getItem('token')) {
  useCsNotifyStore().bootstrapFromLogin(localStorage.getItem('token'))
  useFinancePendingNotifyStore().bootstrapFromLogin()
}

app.mount('#app')
